export const getLatestEditsFetching = (state) => state?.latestEdits?.listingFetching;

export const getLatestEdits = (state) => {
    return state?.latestEdits?.listingResponse || [];
};
